import React from "react";
import { useFieldArray } from "react-hook-form";

//Components
import Form, { Group } from "~/common/components/Form";
import Textarea from "~/common/components/textarea";
import Input from "~/common/components/Input";
import Tag from "~/common/components/Tag";
import Select from "~/common/components/Select";
import { UPLOAD_TYPE } from "~/common/constants/upload";
import MultiImageUploader from "~/common/components/FormImageUploader/MultiImageUploader";

//Assets
import "~/assets/sass/pages/portfolio/portfolioEdit.scss";
import { PlusIcon } from "~/assets/svg/MathIcon";
import { RoundMinusIcon } from "~/assets/svg/InterfaceIcon";

import { useTranslation } from "react-i18next";

const StartupProducts = ({ useForm }) => {
	const { t } = useTranslation();
	const {
		fields: startupProductsFields,
		append: startupProductsAppend,
		remove: startupProductsRemove,
	} = useFieldArray({
		control: useForm.control,
		name: "startupProducts",
	});

	const handleAddStartupProduct = () => {
		startupProductsAppend({
			title: "",
			step: "1",
			description: "",
			keyword: [],
			image: [],
		});
	};

	const handleRemoveStartupProduct = (index) => {
		startupProductsRemove(index);
	};

	return (
		<li className="detail-info-item">
			<div className="title-group">
				<h4 className="detail-info-title">
					{t("pages.portfolio.PortfolioEdit.components.StartupProducts.introService")}
				</h4>
				<button
					type="button"
					className="dashed-btn plus-btn"
					onClick={handleAddStartupProduct}
				>
					<PlusIcon />
					{t("pages.portfolio.PortfolioEdit.components.StartupProducts.addService")}
				</button>
			</div>
			<ul className="service-intro-list">
				{startupProductsFields &&
					startupProductsFields.map((startupProduct, index) => {
						return (
							<li key={startupProduct.id} className="service-intro-form">
								<Form useForm={useForm}>
									<Group className="service-input-group">
										<Input
											required
											name={`startupProducts.${index}.title`}
											placeholder={t(
												"pages.portfolio.PortfolioEdit.components.StartupProducts.serviceName"
											)}
										/>
										<Select
											name={`startupProducts.${index}.step`}
											options={[
												{
													label: t(
														"pages.portfolio.PortfolioEdit.components.StartupProducts.planStage"
													),
													value: "1",
												},
												{
													label: t(
														"pages.portfolio.PortfolioEdit.components.StartupProducts.preProductStage"
													),
													value: "2",
												},
												{
													label: t(
														"pages.portfolio.PortfolioEdit.components.StartupProducts.supplementStage"
													),
													value: "3",
												},
												{
													label: t(
														"pages.portfolio.PortfolioEdit.components.StartupProducts.commercialStage"
													),
													value: "4",
												},
											]}
										/>
									</Group>
									<Textarea
										name={`startupProducts.${index}.description`}
										maxLength={450}
										showCount={true}
										placeholder={t(
											"pages.portfolio.PortfolioEdit.components.StartupProducts.serviceDesc"
										)}
									/>
									<Tag
										name={`startupProducts.${index}.keyword`}
										className="c__tag-wrap service-tag"
									/>
									<MultiImageUploader
										name={`startupProducts.${index}.image`}
										type={UPLOAD_TYPE.COMPANY_PRODUCT}
										width="165px"
										height="104px"
										className={"product-img"}
										maxCount={6}
									/>
									<span className="img-uploader-desc">
										{t(
											"pages.portfolio.PortfolioEdit.components.StartupProducts.upToSix"
										)}
									</span>
								</Form>
								<button
									type="button"
									className="btn-round-delete"
									onClick={() => {
										handleRemoveStartupProduct(index);
									}}
								>
									<RoundMinusIcon />
								</button>
							</li>
						);
					})}
			</ul>
		</li>
	);
};

export default StartupProducts;
